import React from 'react';
import {Box, Heading, HStack, VStack} from 'native-base';
import {BolivarIcon, DollarIcon} from '../icons';
import {message} from '../../utils/messages';

interface Props {
  localBalance?: string;
  foreignBalance?: string;
}

const SummaryAccountItem = (props: Props) => {
  const {localBalance, foreignBalance} = props;

  const color = '#06355E';
  const defaultHeightLine = 7;

  return (
    <Box paddingBottom={2}>
      <HStack width="100%" justifyContent="space-between">
        <Heading
          color={'#858597'}
          fontSize="16"
          fontWeight={'medium'}
          flexWrap="wrap">
          {message('summary-account-label-current')}
        </Heading>
        <HStack>
          <VStack justifyContent="center" space="0">
            <Box
              height={defaultHeightLine}
              justifyContent="center"
              paddingBottom={1}>
              <DollarIcon />
            </Box>
            <Box
              height={defaultHeightLine}
              justifyContent="center"
              paddingBottom={1}>
              <BolivarIcon />
            </Box>
          </VStack>
          <VStack minWidth="30%">
            <Box
              height={defaultHeightLine}
              justifyContent="center"
              paddingLeft="2">
              <Heading
                color={color}
                textAlign="right"
                fontSize="20"
                fontWeight="extrabold">
                {`${foreignBalance}` ?? '-'}
              </Heading>
            </Box>
            <Box
              height={defaultHeightLine}
              justifyContent="center"
              paddingLeft="2">
              <Heading
                color={color}
                textAlign="right"
                fontSize="20"
                fontWeight="extrabold">
                {`${localBalance}` ?? '-'}
              </Heading>
            </Box>
          </VStack>
        </HStack>
      </HStack>
    </Box>
  );
};

export default SummaryAccountItem;
